import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import {
  type TAmountFormData,
  resetForm,
  updateForm,
} from "@/redux/slices/formSlice";
import { EFormIds } from "@/utils/enums";
import { useCallback } from "react";

export const useAmountForm = () => {
  const dispatch = useAppDispatch();

  const formData = useAppSelector(
    (state) => state.form.formData[EFormIds.Amount]
  );

  const updateAmountFormData = useCallback(
    (newFormData: Partial<TAmountFormData>) => {
      dispatch(
        updateForm({
          formId: EFormIds.Amount,
          formData: newFormData,
        })
      );
    },
    [dispatch]
  );

  const resetFormData = useCallback(() => {
    dispatch(resetForm());
  }, [dispatch]);

  return {
    getAmountFormData: useCallback(
      () => formData as TAmountFormData,
      [formData]
    ),
    amountFormData: formData as TAmountFormData,
    updateAmountFormData,
    resetFormData,
  };
};
